/** 작은 QR 그림 — PC 화면에서 휴대폰 카메라로 주소를 넘길 때(설치 안내 등). 그림은 브라우저 안에서 만든다. */
import React, { useMemo } from "react";
import qrcode from "qrcode-generator";

export const MOBILE_INSTALL_URL = "https://loginhs.tlogin.net/?page=install";

export default function QrCode({ value, size = 132, label }) {
  const src = useMemo(() => {
    try {
      const qr = qrcode(0, "M");
      qr.addData(value);
      qr.make();
      const cell = Math.max(2, Math.floor(size / (qr.getModuleCount() + 4)));
      return qr.createDataURL(cell, cell * 2);
    } catch {
      return null;
    }
  }, [value, size]);
  if (!src) return null;
  return <img src={src} width={size} height={size} alt={label || value} style={{ imageRendering: "pixelated", display: "block" }} />;
}
